import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Message } from 'primereact/message';
import { Tooltip } from 'primereact/tooltip';
import { Badge } from 'primereact/badge';
import { Checkbox } from 'primereact/checkbox';


const PasoConfigurarTurnos = ({
                                  turnos,
                                  setTurnos,
                                  toastRef,
                                  nombresTurnos,
                                  tiposServicio,
                              }) => {
    // Estado del turno actual — sin tipoUnidad
    const [turnoActual, setTurnoActual] = useState({
        id: null,
        idTurno: null,
        diasOperacion: [],
        horaInicio: null,
        horaFin: null,
        tipoServicio: null,
    });

    const [modoEdicion, setModoEdicion] = useState(false);
    const [indiceEditando, setIndiceEditando] = useState(null);

    const diasSemana = [
        { label: 'Lun', value: 'LUNES', dia: 'Lunes' },
        { label: 'Mar', value: 'MARTES', dia: 'Martes' },
        { label: 'Mié', value: 'MIERCOLES', dia: 'Miércoles' },
        { label: 'Jue', value: 'JUEVES', dia: 'Jueves' },
        { label: 'Vie', value: 'VIERNES', dia: 'Viernes' },
        { label: 'Sáb', value: 'SABADO', dia: 'Sábado' },
        { label: 'Dom', value: 'DOMINGO', dia: 'Domingo' }
    ];

    // Funciones
    const limpiarFormulario = () => {
        setTurnoActual({
            id: null,
            idTurno: null,
            diasOperacion: [],
            horaInicio: null,
            horaFin: null,
            tipoServicio: null,
        });
        setModoEdicion(false);
        setIndiceEditando(null);
    };

    const validarTurno = () => {
        if (!turnoActual.idTurno) {
            toastRef.current.show({
                severity: 'warn',
                summary: 'Campo requerido',
                detail: 'Por favor, ingrese el nombre del turno',
                life: 3000
            });
            return false;
        }

        if (turnoActual.diasOperacion.length === 0) {
            toastRef.current.show({
                severity: 'warn',
                summary: 'Días requeridos',
                detail: 'Seleccione al menos un día de operación',
                life: 3000
            });
            return false;
        }

        if (!turnoActual.horaInicio && turnoActual.idTurno?.entrance === false) {
            toastRef.current.show({
                severity: 'warn',
                summary: 'Horario requerido',
                detail: 'Ingrese la hora de salida',
                life: 3000
            });
            return false;
        }

        if (!turnoActual.horaFin && turnoActual.idTurno?.entrance === true) {
            toastRef.current.show({
                severity: 'warn',
                summary: 'Horario requerido',
                detail: 'Ingrese la hora de llegada',
                life: 3000
            });
            return false;
        }

        if (!turnoActual.tipoServicio?.id) {
            toastRef.current.show({
                severity: 'warn',
                summary: 'Servicio requerido',
                detail: 'Seleccione el tipo de servicio',
                life: 3000
            });
            return false;
        }

        return true;
    };

    const agregarOActualizarTurno = () => {
        if (!validarTurno()) return;

        if (modoEdicion) {
            const turnosActualizados = [...turnos];
            turnosActualizados[indiceEditando] = { ...turnoActual };
            setTurnos(turnosActualizados);

            toastRef.current.show({
                severity: 'success',
                summary: '¡Actualizado!',
                detail: 'El turno se ha actualizado correctamente',
                life: 3000
            });
        } else {
            const nuevoTurno = {
                ...turnoActual,
                tempId: Date.now(),  // solo para key del listado, nunca al backend
                id: null             // null = nuevo, sin ID de BD
            };
            setTurnos([...turnos, nuevoTurno]);

            toastRef.current.show({
                severity: 'success',
                summary: '¡Agregado!',
                detail: 'El turno se ha agregado correctamente',
                life: 3000
            });
        }

        limpiarFormulario();
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    };

    const cargarTurnoParaEditar = (turno, index) => {
        setTurnoActual({ ...turno });
        setModoEdicion(true);
        setIndiceEditando(index);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const eliminarTurno = (index) => {
        const nuevosTurnos = turnos.filter((_, i) => i !== index);
        setTurnos(nuevosTurnos);

        if (modoEdicion && indiceEditando === index) {
            limpiarFormulario();
        }

        toastRef.current.show({
            severity: 'info',
            summary: 'Eliminado',
            detail: 'El turno se ha eliminado',
            life: 3000
        });
    };

    const toggleDia = (dia) => {
        const dias = turnoActual.diasOperacion.includes(dia)
            ? turnoActual.diasOperacion.filter(d => d !== dia)
            : [...turnoActual.diasOperacion, dia];

        setTurnoActual({ ...turnoActual, diasOperacion: dias });
    };

    const seleccionarTodosDias = () => {
        const todosDias = diasSemana.map(d => d.value);
        setTurnoActual({ ...turnoActual, diasOperacion: todosDias });
    };

    const seleccionarEntreSemana = () => {
        const entreSemanaDias = diasSemana.slice(0, 5).map(d => d.value);
        setTurnoActual({ ...turnoActual, diasOperacion: entreSemanaDias });
    };

    const formatearHora = (fecha) => {
        if (!fecha) return '';
        return fecha.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
    };

    const formatearDias = (dias) => {
        if (dias.length === 0) return 'Sin días';
        if (dias.length === 7) return 'Todos los días';
        return dias.map(d => {
            const dia = diasSemana.find(ds => ds.value === d);
            return dia ? dia.label : '';
        }).join(', ');
    };

    const obtenerNombreServicio = (valor) => {
        const servicio = tiposServicio.find(s => s.id === valor.id);
        return servicio ? servicio.nombre : valor;
    };

    /*const tieneEntradaYSalida = turnos.some(t => t.idTurno?.entrance === true) &&
        turnos.some(t => t.idTurno?.entrance === false);*/

    return (
        <div className="paso-turnos">
            {/* Formulario de turno */}
            <Card className="paso-card">
                <Message
                    severity="info"
                    className="mb-4"
                    content={
                        <div className="flex align-items-center gap-3">
                            <i className="pi pi-clock" style={{ fontSize: '1.5rem' }}></i>
                            <div>
                                <strong>
                                    {modoEdicion ? 'Editar turno' : 'Agregar nuevo turno'}
                                </strong>
                                <p className="m-0 mt-1" style={{ fontSize: '0.9rem' }}>
                                    {modoEdicion
                                        ? 'Modifique los datos del turno'
                                        : 'Configure un turno con su horario y tipo de servicio'}
                                </p>
                            </div>
                        </div>
                    }
                />

                <div className="grid">
                    {/* Nombre del turno */}
                    <div className="col-12 md:col-4">
                        <div className="campo-grupo">
                            <label className="campo-label obligatorio">
                                Nombre del turno
                                <i
                                    className="pi pi-question-circle ml-2 cursor-pointer tooltip-icon"
                                    data-pr-tooltip="Seleccione un turno predefinido"
                                    data-pr-position="right"
                                />
                            </label>
                            <Tooltip target=".tooltip-icon" />
                            <Dropdown
                                value={turnoActual.idTurno}
                                options={nombresTurnos}
                                onChange={(e) => setTurnoActual({
                                    ...turnoActual,
                                    idTurno: e.value,
                                    horaInicio: null,
                                    horaFin: null,
                                })}
                                placeholder="Seleccione un turno"
                                className="w-full"
                                optionLabel="nombre"
                            />
                        </div>
                    </div>

                    {/* Tipo de servicio */}
                    <div className="col-12 md:col-4">
                        <div className="campo-grupo">
                            <label className="campo-label obligatorio">
                                Tipo de servicio
                                <i
                                    className="pi pi-question-circle ml-2 cursor-pointer tooltip-icon"
                                    data-pr-tooltip="Defina el nivel de servicio para este turno"
                                    data-pr-position="left"
                                />
                            </label>

                            <Dropdown
                                value={turnoActual.tipoServicio}
                                options={tiposServicio}
                                onChange={(e) => setTurnoActual({ ...turnoActual, tipoServicio: e.value })}
                                placeholder="Seleccione el tipo de servicio"
                                className="w-full"
                                optionLabel="nombre"
                            />
                        </div>
                    </div>

                    {/* Horarios — condicional según tipo */}
                    {turnoActual.idTurno && (
                        <>
                            {turnoActual.idTurno.entrance === false && (
                                <div className="col-12 md:col-4">
                                    <div className="campo-grupo">
                                        <label className="campo-label obligatorio">Hora de salida</label>
                                        <Calendar
                                            value={turnoActual.horaInicio}
                                            onChange={(e) => setTurnoActual({ ...turnoActual, horaInicio: e.value })}
                                            timeOnly
                                            hourFormat="24"
                                            placeholder="Ingresa el horario de salida de planta"
                                            className="w-full"
                                            icon="pi pi-clock"
                                            showIcon
                                        />
                                    </div>
                                </div>
                            )}

                            {turnoActual.idTurno.entrance === true && (
                                <div className="col-12 md:col-4">
                                    <div className="campo-grupo">
                                        <label className="campo-label obligatorio">Hora de llegada</label>
                                        <Calendar
                                            value={turnoActual.horaFin}
                                            onChange={(e) => setTurnoActual({ ...turnoActual, horaFin: e.value })}
                                            timeOnly
                                            hourFormat="24"
                                            placeholder="Ingresa el horario de llegada a planta"
                                            className="w-full"
                                            icon="pi pi-clock"
                                            showIcon
                                        />
                                    </div>
                                </div>
                            )}
                        </>
                    )}

                    {/* Días de operación */}
                    <div className="col-12">
                        <div className="campo-grupo">
                            <label className="campo-label obligatorio">
                                Días de operación
                                <i
                                    className="pi pi-question-circle ml-2 cursor-pointer tooltip-icon"
                                    data-pr-tooltip="Seleccione los días en que operará este turno"
                                    data-pr-position="right"
                                />
                            </label>

                            {/* Botones rápidos */}
                            <div className="flex gap-2 mb-3">
                                <Button
                                    label="Todos los días"
                                    icon="pi pi-calendar"
                                    onClick={seleccionarTodosDias}
                                    className="p-button-sm p-button-outlined"
                                    size="small"
                                />
                                <Button
                                    label="Lunes a Viernes"
                                    icon="pi pi-calendar"
                                    onClick={seleccionarEntreSemana}
                                    className="p-button-sm p-button-outlined"
                                    size="small"
                                />
                            </div>

                            {/* Selector de días */}
                            <div className="grid dias-selector">
                                {diasSemana.map((dia) => (
                                    <div key={dia.value} className="col-6 sm:col-4 md:col-3 lg:col">
                                        <div
                                            className={`dia-checkbox ${turnoActual.diasOperacion.includes(dia.value) ? 'seleccionado' : ''}`}
                                            onClick={() => toggleDia(dia.value)}
                                        >
                                            <Checkbox
                                                inputId={dia.value}
                                                checked={turnoActual.diasOperacion.includes(dia.value)}
                                                onChange={() => toggleDia(dia.value)}
                                            />
                                            <label htmlFor={dia.value} className="ml-2 cursor-pointer">
                                                <div className="dia-label">{dia.label}</div>
                                                <div className="dia-nombre">{dia.dia}</div>
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Botones de acción */}
                <Divider />
                <div className="flex gap-3 justify-content-end">
                    {modoEdicion && (
                        <Button
                            label="Cancelar"
                            icon="pi pi-times"
                            onClick={limpiarFormulario}
                            className="p-button-outlined p-button-secondary"
                        />
                    )}
                    <Button
                        label={modoEdicion ? 'Actualizar Turno' : 'Agregar Turno'}
                        icon={modoEdicion ? 'pi pi-check' : 'pi pi-plus'}
                        onClick={agregarOActualizarTurno}
                        size="large"
                    />
                </div>
            </Card>

            {/* Lista de turnos agregados */}
            {turnos.length > 0 && (
                <Card className="paso-card mt-4">
                    <div className="flex justify-content-between align-items-center mb-3">
                        <div className="flex align-items-center gap-2">
                            <h3 className="m-0">Turnos configurados</h3>
                            <Badge value={turnos.length} severity="success" />
                        </div>
                    </div>

                    <div className="grid">
                        {turnos.map((turno, index) => (
                            <div key={turno.tempId ?? index} className="col-12 md:col-6 lg:col-4">
                                <div className="turno-mini-card">
                                    <div className="flex justify-content-between align-items-center mb-2">
                                        <Badge value={index + 1} severity="info" />
                                        <div className="flex gap-1">
                                            <Button
                                                icon="pi pi-pencil"
                                                onClick={() => cargarTurnoParaEditar(turno, index)}
                                                className="p-button-rounded p-button-text p-button-sm"
                                                tooltip="Editar"
                                            />
                                            <Button
                                                icon="pi pi-trash"
                                                onClick={() => eliminarTurno(index)}
                                                className="p-button-rounded p-button-text p-button-danger p-button-sm"
                                                tooltip="Eliminar"
                                            />
                                        </div>
                                    </div>

                                    <h4 className="turno-nombre">{turno.idTurno?.nombre}</h4>

                                    <div className="turno-horario mb-2">
                                        <i className="pi pi-clock"></i>
                                        {formatearHora(turno.horaInicio)} - {formatearHora(turno.horaFin)}
                                    </div>

                                    <div className="flex flex-column gap-2">
                                        <div className="turno-tag tag-dias">
                                            <i className="pi pi-calendar"></i>
                                            {formatearDias(turno.diasOperacion)}
                                        </div>
                                        <div className="turno-tag tag-servicio">
                                            <i className="pi pi-briefcase"></i>
                                            {obtenerNombreServicio(turno.tipoServicio)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Card>
            )}

            {turnos.length === 0 && (
                <Message
                    severity="info"
                    className="mt-4"
                    text="Aún no has agregado turnos. Complete el formulario arriba y presione 'Agregar Turno'."
                />
            )}

            {/*{turnos.length > 0 && !tieneEntradaYSalida && (
                <Message
                    severity="warn"
                    className="mt-3"
                    text={`Falta agregar un turno de ${turnos.some(t => t.idTurno?.entrance) ? 'Salida' : 'Entrada'} para continuar.`}
                />
            )}*/}
        </div>
    );
};

export default PasoConfigurarTurnos;
